import type { DevBadgeView } from "./DevBadgeView";
import type { DevControlPort } from "./DevControlPort";
import type { DevToolsConfig } from "./DevToolsConfig";
import { DevBadgePresenter } from "./DevBadgePresenter";
import { DevHotkeys } from "./DevHotkeys";
import type { Log } from "@slot/presentation";

/**
 * DevTools orchestration (Game-Shell).
 * - owns dev badge
 * - owns hotkeys
 * - talks to the outside world only through DevControlPort
 */
export class DevTools {
  private readonly cfg: DevToolsConfig;
  private readonly badgePresenter: DevBadgePresenter;
  private readonly hotkeys: DevHotkeys;

  public constructor(input: {
    config: DevToolsConfig;
    badgePanel: DevBadgeView;
    devControl: DevControlPort;
    log?: Log;
  }) {
    this.cfg = input.config;

    this.badgePresenter = new DevBadgePresenter({
      panel: input.badgePanel,
      config: input.config,
    });

    this.hotkeys = new DevHotkeys({
      config: input.config,
      devControl: input.devControl,
      log: input.log,
    });
  }

  public start(): void {
    if (!this.cfg.enabled) return;
    this.badgePresenter.start();
    this.hotkeys.start();
  }

  public stop(): void {
    this.hotkeys.stop();
    this.badgePresenter.stop();
  }
}